module.exports = __webpack_public_path__ + "img/unchecked.49ffd2c8.svg";